enum ItemType {
    Show,
    Movie,
    Unknown
}

export default ItemType;